import { parsePhoneNumberFromString } from "libphonenumber-js";

/** Google Ads enhanced conversions fields for parent gtag('set', 'user_data', …). Omit empties. */
export interface IParentEnhancedConversionUserData {
    email?: string;
    phone_number?: string;
}

export function normalizeEmailForEnhancedConversion(raw?: string | null): string {
    if (!raw) return "";
    return raw.trim().toLowerCase();
}

/** Default IE — LowQuote quote forms are Ireland-focused. */
export function normalizePhoneForEnhancedConversion(raw?: string | null, defaultCountry: "IE" | "GB" = "IE"): string {
    if (!raw) return "";
    const trimmed = raw.trim();
    if (!trimmed) return "";

    const parsed = parsePhoneNumberFromString(trimmed, defaultCountry);
    if (parsed && parsed.isValid()) return parsed.format("E.164");

    return "";
}

export function buildEnhancedConversionUserDataForParent(params: {
    email?: string | null;
    phoneNumber?: string | null;
}): IParentEnhancedConversionUserData {
    const email = normalizeEmailForEnhancedConversion(params.email);
    const phone_number = normalizePhoneForEnhancedConversion(params.phoneNumber);

    const userData: IParentEnhancedConversionUserData = {};
    if (email) userData.email = email;
    if (phone_number) userData.phone_number = phone_number;
    return userData;
}
